import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter" }
const _hoisted_2 = {
  class: "gfu-grid__cell gfu-1of1",
  "data-qa": "order-details:shippingAddress"
}
const _hoisted_3 = { class: "gfu-heading gfu-heading--top-divider _mb-3" }
const _hoisted_4 = { class: "_my-3" }
const _hoisted_5 = {
  key: 0,
  class: "gfu-grid gfu-grid--small"
}
const _hoisted_6 = { class: "gfu-field__label gfu-field__label--big gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-1of3--l _tal" }
const _hoisted_7 = {
  key: 0,
  class: "gfu-field__value gfu-field__value--big gfu-grid__cell gfu-1of2 gfu-1of2--m gfu-2of3--l _tal",
  "data-qa": "order-details:Shipping"
}
const _hoisted_8 = {
  key: 0,
  class: "gfu-grid__cell _fc"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_address_display = _resolveComponent("address-display")
  const _component_base_button = _resolveComponent("base-button")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.Resources.YourPledge.ShippingSectionHeader), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_base_icon, { name: "circle-info" }),
        _createTextVNode(" " + _toDisplayString(_ctx.Resources.YourPledge.ShippingInfoPartiallyCollectedNotificationText), 1 /* TEXT */)
      ]),
      ($props.shippingModel)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.Resources.YourPledge.ShippingInfoLabel), 1 /* TEXT */),
            ($options.shippingInfo)
              ? (_openBlock(), _createElementBlock("label", _hoisted_7, _toDisplayString($options.shippingInfo), 1 /* TEXT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createVNode(_component_address_display, {
        address: $props.shippingAddress,
        "show-location-only": true
      }, null, 8 /* PROPS */, ["address"])
    ]),
    ($props.canChangeShippingAddress)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_base_button, {
            display: "fixed",
            shape: "default",
            onClick: _withModifiers($options.changeShipping, ["prevent"]),
            "data-qa": "order-details:ChangeShipping"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.Resources.YourPledge.ManageShippingButton), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["onClick"])
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}